var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlame = function SvgIconFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-flame_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-flame_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M23.5 21.956c3.402-4.825.243-11.409-1.459-13.04 0 4.952-3.259 7.728-5.347 9.78-2.086 2.053-3.402 5.28-3.402 8.15 0 5.401 4.57 9.779 10.208 9.779s10.208-4.378 10.208-9.78c0-2.496-1.796-6.42-3.402-8.149-3.04 4.89-4.75 4.89-6.806 3.26Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-flame_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-flame_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h35v35H6z"
  })))));
};
export default SvgIconFlame;